import React, { useState, useEffect, useRef } from "react";
import classes from "./styles.module.scss";
import {text} from "./constants.js"
import useToast from "../../Hooks/useToast.js";
import { toast } from "react-toastify";
import { ocrUpload } from "../../Api/services/ocr.js";

export const OCRPDF = () => {
    const {showToast} = useToast();
    const [file, setFile] = useState(null);
    const [fileText, setFileText] = useState('')
    const [uploading, setUploading] = useState(false)
    const fileInputRef = useRef(null);

    const getText = (file) => {
        setUploading(true)
        let formData = new FormData();
        formData.append("pdfFile", file)

        ocrUpload(formData).then(res=>{
            setFileText(res)
            setUploading(false)
        }).catch(err=>{
            showToast(text.errorMsg, 'error')
            console.log(err)
            setUploading(false)
        })
    }
    
    const handleDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files[0].type==='application/pdf') {
            getText(e.dataTransfer.files[0]);
        } else {
            toast(text.onlyAudioMsg, 'error')
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleFileChange = (e) => {
        getText(e.target.files[0]);
    };
    
    const handleClick = () => {
        fileInputRef.current.click();
    };
    
    return (
        <div className={classes.container}>
            <h1>{text.pageTitle}</h1>
                <div className={classes.sttContainer}>
                    <div
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onClick={handleClick}
                        className={classes.uploadContainer}>
                        {uploading ? text.uploadingMsg : text.dragMsg}
                        <input 
                            type="file"
                            accept=".pdf"
                            ref={fileInputRef} 
                            onChange={handleFileChange}/>
                    </div>
                    <div className={classes.leftBoxContainer}>
                        <div className={classes.textContainer}>
                            {fileText ? 
                            fileText.split('\n').map(line => <p>{line}</p>)
                            : text.textPlaceholder}
                        </div>
                        {/* <div className={classes.buttonsContainer}>
                            <button className={classes.button} >summarize</button>
                        </div> */}

                    </div>
                </div>
        </div>
    );
}
